import React from "react";
import PropTypes from "prop-types";
// import {Dimmer, Loader} from "semantic-ui-react";
import "../../assets/css/normalize.css";
import "../../assets/css/app.css";
import { sistemasDisponiveis } from "../../view/inicio/acoes/ApiActions";
import Navegacao from "../navegacao/Navegacao";
import NotificationSystem from "react-notification-system";
import { Dialog, Progress, Content, Header, Footer } from "react-template";
import { connect } from "react-redux";
import "../../helpers/MaskDefinitions";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayDialog: false,
      dialogPathname: null,
      modalTitle: "",
      modalDescription: "",
      modalBody: "",
      onAgree: null,
      onCancel: null,
      loading: true,
      auth: this.props.auth,
      displaySideMenu: false,
      fixedContent: false,
      tabOptions: null,
      toolbar: null,
      floatToolbar: false,
      displayRightNav: false,
      dimmer: false,
      dimmerText: "",
      sistemas: []
    };
    this.onDisplaySideMenu = this.onDisplaySideMenu.bind(this);
    this.displayToolbar = this.displayToolbar.bind(this);
    this.removeToolbar = this.removeToolbar.bind(this);
    this.openRightNav = this.openRightNav.bind(this);
    this.closeRightNav = this.closeRightNav.bind(this);
  }

  componentWillMount() {
    this.getSistemas();
    this.setState({ loading: true });
  }

  componentWillReceiveProps(nextProps) {
    const pathname = nextProps.router.location.pathname;
    if (
      this.state.dialogPathname !== null &&
      this.state.dialogPathname !== pathname
    ) {
      this.setState({ displayDialog: false, dialogPathname: null });
    }
  }

  getAuth = () => {
    return this.state.auth;
  };

  getSistemas() {
    sistemasDisponiveis(
      res => {
        this.setState({ sistemas: res.data.sistemas });
      },
      error => {
        this.setState({ sistemas: [] });
      }
    );
  }

  displayToolbar(toolbar, float) {
    this.setState({
      toolbar: toolbar,
      floatToolbar: float
    });
  }

  openRightNav() {
    this.setState({
      displayRightNav: true
    });
  }

  closeRightNav() {
    this.setState({
      displayRightNav: false
    });
  }

  removeToolbar() {
    this.setState({
      toolbar: null,
      floatToolbar: false,
      displayRightNav: false
    });
  }

  setTabOptions = options => {
    this.setState({
      tabOptions: options
    });
  };

  removeTab = () => {
    this.setState({
      tabOptions: null
    });
  };

  getDimmer = () => {
    if (this.state.dimmer)
      return (
        // <Dimmer active={true}>
        //     <Loader>{this.state.dimmerText}</Loader>
        // </Dimmer>
        alert("Indisponível.")
      );
  };

  setDimmer = text => {
    const dimmerText = text || "Executando ação. Aguarde...";
    let dimmer = true;
    if (text === false) dimmer = false;
    this.setState({ dimmerText, dimmer });
  };

  componentDidMount() {
    setTimeout(() => this.setState({ loading: false }), 2000);
  }

  getDialog = () => {
    if (this.state.displayDialog)
      return (
        <Dialog
          modalTitle={this.state.modalTitle}
          modalDescription={this.state.modalDescription}
          onAgree={this.state.onAgree}
          onCancel={this.state.onCancel}
          displayFunction={this.setDisplayModal}
        >
          {this.state.modalBody}
        </Dialog>
      );
  };

  getChildContext() {
    return {
      setModalConfig: this.setModalConfig,
      setDisplayModal: this.setDisplayModal,
      notificationSystem: this.getNotificationSystem,
      getAuth: this.getAuth,
      setTabOptions: this.setTabOptions,
      removeTab: this.removeTab,
      displayToolbar: this.displayToolbar,
      removeToolbar: this.removeToolbar,
      openRightNav: this.openRightNav,
      closeRightNav: this.closeRightNav,
      setDimmer: this.setDimmer
    };
  }

  setModalConfig = (title, description, content, onAngree, onCancel) => {
    this.setState({
      modalTitle: title,
      modalDescription: description,
      modalBody: content,
      onAgree: onAngree,
      onCancel: onCancel
    });
  };

  setDisplayModal = boolean => {
    const dialogPathname = this.props.router.location.pathname;
    this.setState({ displayDialog: boolean, dialogPathname });
  };

  setFixedContent(boolean) {
    this.setState({ fixedContent: boolean });
  }

  getNotificationSystem = () => this.notificationSystem;

  componentWillUpdate(nextProps, nextState) {
    if (this.state.auth !== nextProps.auth)
      this.setState({ auth: nextProps.auth });
  }

  onDisplaySideMenu(boolean) {
    this.setState({ displaySideMenu: boolean });
  }

  render() {
    let tituloPrincipal = "";
    this.props.routes.forEach(item => {
      tituloPrincipal = item.titulo || "";
    });

    return (
      <div className="app-module">
        {this.getDimmer()}
        {this.state.loading ? <Progress /> : null}
        {this.getDialog()}
        <NotificationSystem ref={n => (this.notificationSystem = n)} />
        <div
          className={
            "mdl-layout mdl-js-layout mdl-layout--fixed-drawer mdl-layout--fixed-header" +
            (this.state.fixedContent ? " fixed-content" : "")
          }
        >
          <Header
            titulo={tituloPrincipal}
            onDisplayMenu={this.onDisplaySideMenu}
            tabsOptions={this.state.tabOptions}
            appMenu
            sistemas={this.state.sistemas}
          />
          <Navegacao
            auth={this.state.auth}
            displayNav={this.state.displaySideMenu}
          />
          <Content
            {...this.props}
            toolbar={this.state.toolbar}
            floatToolbar={this.state.floatToolbar}
            toolbarAlign="right"
            displayRightNav={this.state.displayRightNav}
            closeRightNav={this.closeRightNav}
          >
            {this.props.children}
          </Content>
          <Footer
            descricao={
              "UEPB - " +
              process.env.REACT_APP_NAME +
              " - " +
              process.env.REACT_APP_DESCRIPTION
            }
          />
          {/*<Base titulo={tituloPrincipal} descricao={'UEPB - '+APP_NAME+' - '+APP_DESCRIPTION} {...this.props}>*/}
          {/*{this.props.children}*/}
          {/*</Base>*/}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { auth: state.auth };
}

export default connect(mapStateToProps)(App);

App.childContextTypes = {
  setModalConfig: PropTypes.func,
  setDisplayModal: PropTypes.func,
  notificationSystem: PropTypes.func,
  getAuth: PropTypes.func,
  setTabOptions: PropTypes.func,
  removeTab: PropTypes.func,
  displayToolbar: PropTypes.func,
  removeToolbar: PropTypes.func,
  openRightNav: PropTypes.func,
  closeRightNav: PropTypes.func,
  setDimmer: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/containers/App.js